<template>
    <v-date-picker
        v-if="type === 'date'"
        v-bind="props"
        v-model="dateValue"
        v-model:month="monthModel"
        v-model:year="yearModel"
        v-model:view-mode="viewMode"
        :multiple="multipleValue"
        :width="widthValue"
    />
    <MonthPicker v-else-if="type === 'month'" v-bind="{ ...props }" v-model="model" />
    <div v-else>Unsupported type</div>
</template>
<script lang="ts" setup>
/**
 * Vuetify 3 VDatePicker Wrapper. Allows to use v-model with string or Date
 */
import moment from "moment-timezone";
import { computed } from "vue";
import { MonthPicker } from "./month-picker";
import { useDefaults } from "vuetify/lib/framework.mjs";
import { getDBFormattedDate } from "@/services/dateServices";

interface IProps {
    active?: string | string[];
    allowedDates?: string[] | Date[] | ((date: unknown) => boolean);
    // locale?: string;
    landscape?: boolean;
    color?: string;
    scrollable?: boolean;
    disabled?: boolean;

    firstDayOfWeek?: string | number;
    height?: string | number;
    hideHeader?: boolean;
    max?: Date | string;
    min?: Date | string;
    multiple?: number | boolean | (string & {}) | "range";
    position?: "fixed" | "relative" | "static" | "absolute" | "sticky";
    rounded?: string | number | boolean;
    showWeek?: boolean;
    title?: string;
    // viewMode?: "month" | "year" | "months";
    width?: string | number;
    // year?: number;
    bgColor?: string;
    border?: boolean;
    displayValue?: unknown;
    elevation?: string | number;
    header?: string;
    hideWeekdays?: boolean;
    location?: any;
    minHeight?: string | number;
    maxHeight?: string | number;
    showAdjacentMonths?: boolean;

    // Extra props for compatibility with previous use in bobbee
    range?: boolean; // Equivalent of multiple = "range"
    fullWidth?: boolean;
    returnDateStringFormat?: string; // Returns output in a given format. Only works if date input is not an object
    type?: "date" | "month";
}

const props_ = withDefaults(defineProps<IProps>(), {
    // locale: "fr",
    landscape: false,
    color: "gradient",
    scrollable: false,
    hideHeader: false,
    type: "date",
    // viewMode: "month",
});

const props = useDefaults(props_);

const model = defineModel<string | Date | null | string[] | Date[]>({ default: null });
const monthModel = defineModel<string | number>("month");
const yearModel = defineModel<number>("year");
const viewMode = defineModel<"month" | "year" | "months">("viewMode", { default: "month" });

const dateValue = computed({
    get: () => {
        if (!Array.isArray(model.value)) {
            return model.value ? moment(model.value).toDate() : model.value;
        } else {
            return model.value.map((date) => moment(date).toDate());
        }
    },
    set: (value) => {
        if (Array.isArray(value)) {
            const valueType = typeof model.value[0];
            model.value = [...new Set(value.map((date) => dateToType(date, valueType)))];
        } else {
            const valueType = typeof model.value;
            model.value = dateToType(value, valueType);
        }
    },
});

const dateToType = (value, valueType) => {
    // debugger;
    if (valueType === "string") {
        const format = props.returnDateStringFormat || "YYYY-MM-DD";
        return getDBFormattedDate(value, format);
    } else if (valueType === "object" && value instanceof Date) {
        return moment(getDBFormattedDate(value)).toDate();
    } else {
        if (props.returnDateStringFormat) {
            return getDBFormattedDate(value, props.returnDateStringFormat);
        }
        return value;
    }
};

const multipleValue = computed(() => {
    if (props.range) {
        return "range";
    }
    return props.multiple;
});

const widthValue = computed(() => {
    if (props.fullWidth) {
        return "100%";
    }
    return props.width;
});
</script>
